import React, { useState, useMemo, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import throttle from 'lodash/fp/throttle';
import { _ParentFrame } from '../../../Frame/types/Frame';
import { useHistory, useLocation } from 'react-router-dom';
// Форк react-use-scroll-spy:
// https://github.com/Purii/react-use-scrollspy
//
// * Исправил баг с неверной активной секцией после скроллинга вниз и затем снова вверх.
// * Добавил мемоизацию хэндлера.
// * Корректировка зависимостей useEffect.
function useScrollSpy({ offsetPx = 0, sectionElementRefs = [], throttleMs = 100, }) {
    const [activeSection, setActiveSection] = useState(0);
    const handle = useMemo(() => throttle(throttleMs, () => {
        let currentSectionId = 0;
        for (let i = 0; i < sectionElementRefs.length; i++) {
            const section = sectionElementRefs[i].current;
            if (!section || !(section instanceof Element))
                continue;
            if (section.getBoundingClientRect().top + offsetPx < 0) {
                currentSectionId = i;
                continue;
            }
            break;
        }
        setActiveSection(currentSectionId);
    }), [sectionElementRefs, offsetPx, throttleMs]);
    useEffect(() => {
        window.addEventListener('scroll', handle);
        handle();
        return () => {
            window.removeEventListener('scroll', handle);
        };
    }, [handle]);
    return activeSection;
}
const useStyles = makeStyles({
    root: {
        position: 'sticky',
        top: -1,
        background: '#fff',
        zIndex: 1100,
        margin: '10px -20px',
        padding: '0 20px',
        '&:before': {
            left: 0,
            bottom: 0,
            width: '100%',
            content: '" "',
            position: 'absolute',
            borderBottom: '1px solid #eee',
        }
    }
});
export default function DescriptionMenu(props) {
    var _a, _b;
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const rootRef = useRef(null);
    const rootHeight = (_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
    const scrollSpyOptions = useMemo(() => ({
        sectionElementRefs: props.items.map(x => x.ref),
        offsetPx: -rootHeight,
    }), [props.items, rootHeight]);
    const index = useScrollSpy(scrollSpyOptions);
    const handleTabClick = (ref) => {
        if (!ref.current)
            return;
        const targetY = ref.current.offsetTop - window.scrollY - rootHeight + 1;
        const parentFrame = _ParentFrame();
        if (props.isFrame && parentFrame) {
            parentFrame.sendMessage({ message: 'scroll', top: targetY, behavior: 'smooth' });
        }
        else {
            window.scrollBy({ top: targetY, behavior: 'smooth' });
            if (ref.current.id)
                history.replace(Object.assign(Object.assign({}, location), { hash: `#${ref.current.id}` }));
        }
    };
    useEffect(() => {
        if (location.hash) {
            const hashElement = document.getElementById(location.hash.replace('#', ''));
            if (!hashElement)
                return;
            window.scrollBy({ top: hashElement.offsetTop - window.scrollY - rootHeight + 1, behavior: 'smooth' });
        }
    }, []);
    useEffect(() => {
        var _a;
        if (!props.items || index < 0 || index >= props.items.length)
            return;
        const ref = props.items[index].ref;
        if ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.id)
            history.replace(Object.assign(Object.assign({}, location), { hash: `#${ref.current.id}` }));
    }, [index, props.items]);
    return React.createElement("div", { ref: rootRef, className: classes.root },
        React.createElement(Tabs, { variant: "scrollable", value: index }, props.items.map((x, i) => React.createElement(Tab, { label: x.label, disableRipple: true, onClick: handleTabClick.bind(null, x.ref), key: x.label }))));
}
